export default function checkObj(keys: string[], obj: any) {
  let hasAll: boolean = true
  const missedProperties: string[] = []
  keys.forEach((x) => {
    if (!(x in obj)) {
      hasAll = false
      missedProperties.push(x)
    }
  })
  return {
    hasAll,
    missedProperties,
  }
}
